var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.$attrs.label,"vid":_vm.$attrs.vid,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var valid = ref.valid;
return _c('v-textarea',_vm._g(_vm._b({attrs:{"error-messages":errors,"success":valid,"hide-details":"auto"},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-textarea',_vm.$attrs,false),_vm.$listeners))}}])})}
var staticRenderFns = []

export { render, staticRenderFns }